module.exports = __webpack_public_path__ + "img/automated_export_plugin.60f982ee.svg";